module.exports = __webpack_public_path__ + "static/media/Ø2_1.2bb9b78f.png";